module.exports = __webpack_public_path__ + "static/media/line-icon.8df3bd4e.svg";